import { useContext } from 'react';

import GlobalBottomSheetContext from 'components/GlobalBottomSheet/globalBottomSheetContext';

const useGlobalBottomSheet = () => useContext(GlobalBottomSheetContext);

export default useGlobalBottomSheet;
